export enum ILiveResultChartType {
  CATEGORICAL,
  SCALE,
}
